module.exports = __webpack_public_path__ + "img/spirit_900.36ea98be.png";